import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHandPaper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.625 4.531C13.875 4.375 15 5.344 15 6.594v4.125c-.031.406-.094 1.031-.187 1.437l-.938 4.094c-.094.438-.5.781-.969.781H5.937c-.28 0-.656-.218-.812-.437l-3.75-5.25c-.656-.938-.469-2.25.469-2.906a1.98 1.98 0 0 1 1.937-.282V4.187c0-1.375 1.281-2.343 2.563-2a2.045 2.045 0 0 1 3.687-.03c1.344-.344 2.594.687 2.594 2.03zm.844 6.188V6.594c0-.75-1.125-.782-1.125.031V9c0 .281-.219.5-.5.5h-.219a.494.494 0 0 1-.5-.5V4.188c0-.782-1.156-.813-1.156 0V9c0 .281-.219.5-.5.5H9.28a.494.494 0 0 1-.5-.5V3.125c0-.781-1.156-.812-1.156-.031V9c0 .281-.219.5-.5.5h-.219a.494.494 0 0 1-.5-.5V4.219c0-.782-1.125-.813-1.125-.032v6.47c0 .5-.625.687-.906.28L3.5 9.75c-.437-.625-1.344.094-.906.719L6.188 15.5H12.5l.875-3.687c.063-.344.094-.72.094-1.094"
    />
  </svg>
);
export default SvgHandPaper;
